
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/verify-phone",
      function () {
        return require("private-next-pages/auth/verify-phone.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/verify-phone"])
      });
    }
  